import CryptoJS from 'crypto-js';
import {getVideoRatio, initDevice} from "../../../../utils";
import {documentValidator, validateSignature} from "../../../../services/documentValidator";
import {EVENT_TRACER} from "../../../../constants";
import {onReportEvent} from "../index";

export function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

const cv = window.cv;
const MAX_FPS_DETECTION_VALUE = 500 // Optimizado: Reducir carga de requestAnimationFrame
export class Detector {
    static croppedImage = true
    static hasResponseToValidation = false

    constructor({stream, device, modelPath, croppedImage, urlService, isFront, documentType, processId, onStatusChange}) {
        this.probabilityThreshold = 50;
        this.counterSuccessfulResults = 0;
        this.MAX_FPS_DETECTION = MAX_FPS_DETECTION_VALUE;
        this.rendering = {
            now: 0,
            elapsed: 0,
            then: 0,
        };
        this.MAX_NUMBER_FACES = 1;
        this.MAX_ANGLE_TURN_HEAD = 30;
        this.MIN_FACE_SIZE_FOR_MOBILE = 224;
        this.MIN_FACE_SIZE_FOR_DESKTOP = 350;
        this.MIN_OCCUPIED_SPACE_FOR_DESKTOP = 15;
        this.MIN_OCCUPIED_SPACE_FOR_MOBILE = 15;
        this.X_OFFSET_FROM_FRAME = 15;
        this.Y_OFFSET_FROM_FRAME = 5;
        this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING = 1;
        this.videoRatio = 1;
        this.showDetectedFace = false;
        this.headTurnCounter = 0;
        this.counterSuccessfulHeadTurns = 0;
        this.stream = stream;
        this.isMobile = device.isMobile;
        this.modelPath = modelPath;
        this.croppedImage = croppedImage
        this.urlService = urlService
        this.documentType = documentType
        this.isFront = isFront
        this.processId = processId
        this.onStatusChange = onStatusChange

        this.ws = null
        this.clientId = null
        this.isProcessing = false
        this.lastStatus = null
        this.autoCapture = false
        this.autoCaptureInterval = null
        this.captureIntervalMs = 500 // Optimizado: 2 capturas por segundo
    }
    setProbabilityThreshold(val) {
        this.probabilityThreshold = val;
    }
    static getInstance(detectorProperties) {
        if (!Detector.instance) {
            Detector.instance = new Detector(detectorProperties);
        }
        return Detector.instance;
    }
    updateHtmlElements(videoElement) {
        this.videoElement = videoElement;
    }
    static async initDetector(modelPath) {

        if (!isMobile()) {
            await this.loadingModels(modelPath);
        }

    }
    static async loadingModels(modelPath) {
        if (!this.modelsLoaded()) {

        }
    }
    static modelsLoaded() {
        return false
    }
    static async warmingUpModels() {
        // const image = new Image();
        // image.src = base64Photo;
        // await this.detectAllFaces(image);
    }

    static async generateHash(blobImage, processId) {
        return new Promise(async (resolve, reject) => {
            try {
                const arrayBuffer = await blobImage.blob.arrayBuffer();

                if (!arrayBuffer || arrayBuffer.byteLength === 0) {
                    throw new Error('Image arrayBuffer is empty');
                }

                console.log('Image ArrayBuffer Length:', arrayBuffer.byteLength);

                const uint8Array = new Uint8Array(arrayBuffer);

                const processIdBytes = new TextEncoder().encode(processId);

                const combinedData = new Uint8Array(processIdBytes.length + uint8Array.length);
                combinedData.set(processIdBytes, 0);
                combinedData.set(uint8Array, processIdBytes.length);

                const wordArray = CryptoJS.lib.WordArray.create(combinedData);


                const hash = CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Base64);
                resolve({
                    hash,
                    preparedFile: blobImage.blob,
                });
            } catch (e) {
                reject(e)
            }
        })
    }

    static async prepareImageForUpload(blobImage, processId) {
        return new Promise(async (resolve, reject) => {
            try {
                const {hash, preparedFile} = await this.generateHash(blobImage, processId)

                const signatureResponse = await fetch('https://api-dev.ado-tech.com/api/key/generate-signature', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ hash, durationMinutes: 30, processId })
                });
                if (!signatureResponse.ok) {
                    const errorText = await signatureResponse.text();
                    throw new Error(`Failed to get signature: ${errorText}`);
                }
                const { signature, expiresAt } = await signatureResponse.json();
                console.log('Received Signature Response:', { signature, expiresAt });
                if (!signature) {
                    throw new Error('Signature is empty or invalid');
                }

                resolve({ preparedFile, hash, signature, expiresAt, processId });
            } catch (e) {
                reject(e)
            }
        })
    }

    static async resizeBase64(base64, width, height, quality, changeQuality = true) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                if (changeQuality) {
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d', {
                        alpha: false,
                        desynchronized: false,
                        willReadFrequently: false
                    });
                    // Configurar para máxima calidad
                    ctx.imageSmoothingEnabled = true;
                    ctx.imageSmoothingQuality = 'high';
                    ctx.drawImage(img, 0, 0, width, height);
                } else {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d', {
                        alpha: false,
                        desynchronized: false,
                        willReadFrequently: false
                    });
                    ctx.imageSmoothingEnabled = true;
                    ctx.imageSmoothingQuality = 'high';
                    ctx.drawImage(img, 0, 0);
                }

                canvas.toBlob(
                    (blob) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            resolve({
                                blob,
                                base64: reader.result
                            });
                        };
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    },
                    'image/webp',
                    1.0
                );
            };
            img.onerror = reject;
            img.src = base64;
        });
    }
    static async detectAllFaces(videoSrc, croppedImage, urlService, documentType, isFront, processId) {
        if (this.hasResponseToValidation) {
            return
        }
        this.hasResponseToValidation = true
        let result = {
            isCard: false,
            image: '',
            documentName: '',
            documentMatch: false,
            status: 'no_detected'
        }
        try {
            onReportEvent(EVENT_TRACER.SERVICE.InitDetection, "Iniciando detección").catch();
            const width = videoSrc.videoWidth;
            const height = videoSrc.videoHeight;

            const originalCanvas = document.createElement('canvas');
            originalCanvas.width = width;
            originalCanvas.height = height;

            const contextOriginal = originalCanvas.getContext('2d', {
                alpha: false,
                desynchronized: false,
                willReadFrequently: false
            });
            // Configurar para máxima calidad
            contextOriginal.imageSmoothingEnabled = true;
            contextOriginal.imageSmoothingQuality = 'high';
            contextOriginal.drawImage(videoSrc, 0, 0, originalCanvas.width, originalCanvas.height);

            const originalImage = originalCanvas.toDataURL('image/webp', 1.0);
            onReportEvent(EVENT_TRACER.SERVICE.CreateBase64Image, "Iniciando proceso de creación de base64").catch();
            const blobImage = await this.resizeBase64(originalImage, width, height, 1);
            onReportEvent(EVENT_TRACER.SERVICE.Base64ImageCreated, "Base64 de la imagen creada").catch();

           if (processId && processId.length > 0) {
               onReportEvent(EVENT_TRACER.SERVICE.SignImage, "Iniciando proceso de firmado de imagen").catch();
               const {preparedFile, hash, signature, expiresAt} = await this.prepareImageForUpload(blobImage, processId)
               onReportEvent(EVENT_TRACER.SERVICE.ImageSigned, "Finalizo proceso de firmado de imagen").catch();

               onReportEvent(EVENT_TRACER.SERVICE.InitValidateSignature, "Iniciando proceso de validación de firma de imagen").catch();
               const responseSignature = await validateSignature({
                   preparedFile,
                   signature,
                   hash,
                   expiresAt,
                   processId
               });

               onReportEvent(EVENT_TRACER.SERVICE.EndValidateSignature, "Finalizó proceso de validación de firma de imagen").catch();

               if (responseSignature.status !== 200 || responseSignature.data !== 'Valida Sign') {
                   onReportEvent(EVENT_TRACER.SERVICE.FailedValidateSignature, "La firma de la imagen no es valida").catch();
                   this.hasResponseToValidation = false
                   return result
               }
           }

            onReportEvent(EVENT_TRACER.SERVICE.SendingImageToValidate, "Enviando imagen al backend").catch();
            const response = await documentValidator({
                base64Data: blobImage.blob,
                urlService,
                isFront,
                documentType,
                processId,
            })
            onReportEvent(EVENT_TRACER.SERVICE.SendingImageToValidateFinish, `Respuesta del backend (${response.data.status || 'no_detected'})`).catch();

            this.hasResponseToValidation = false
            result.isCard = response.data.quality
            result.image = blobImage.base64;
            result.documentMatch = response.data.documentTypeMatch
            result.status = response.data.status || 'no_detected'

            if (this.instance && this.instance.stream) {
                this.instance.stream.returnStatus(result.status);
            }

            if (response.data.quality) {
                result.documentName = response?.data?.result?.documentName;
                result.status = 'detected';
            } else {
                result.documentName = "";
                result.status = 'no_detected';
            }
            return result;
        }
        catch (e) {
            result.status = 'error';
            if (this.instance && this.instance.stream) {
                this.instance.stream.returnStatus('error');
            }
            return result;
        }
    }
    async startDetector() {
        if (!this.videoElement)
            throw Error("Video element not found");
        if (this.videoElement.clientWidth === 0)
            throw Error("Video element too small");
        this.rendering.then = Date.now();
        this.counterSuccessfulResults = 0;
        this.updateForIos();
        this.videoRatio = getVideoRatio(this.videoElement);
        if (!Detector.modelsLoaded()) {
            await Detector.initDetector(this.modelPath);
        }
        this.requestAnimationFrame = requestAnimationFrame(() => this.detection());
    }
    stopDetector() {
        if (this.requestAnimationFrame) {
            // @ts-ignore
            cancelAnimationFrame(this.requestAnimationFrame); // TODO
            this.requestAnimationFrame = undefined;
            if (this.innerCanvas)
                this.innerCanvas.remove();
            this.innerCanvas = undefined;
        }

        // Stop auto capture and clear intervals
        this.stopAutoCapture()

        // Disconnect WebSocket connection
        this.disconnectWebSocket()

        // Reset processing state
        this.isProcessing = false
        this.lastStatus = null
        this.clientId = null

        console.log("CONNECTION: Detector completamente detenido y limpiado")
    }
    updateForIos() {
        const device = initDevice();
        if (device.isIos) {
            this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING = 1;
            this.MAX_FPS_DETECTION = MAX_FPS_DETECTION_VALUE; // Optimizado: Mantener la misma velocidad en iOS
            Detector.isIos = true;
        }
    }
    async detection() {
        console.log("Iniciando detección con WebSocket")
        this.connectWebSocket()
        setTimeout(() => {
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.startAutoCapture()
            }
        }, 1000)
    }

    captureAndSend() {
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
            console.log("ERROR: WebSocket no está conectado")
            return
        }

        // No enviar si ya está procesando para evitar saturar
        if (this.isProcessing) {
            console.log("INFO: Saltando captura - procesamiento en curso")
            return
        }

        const imageData = this.captureImage()
        if (!imageData) return

        // Usar configuración por defecto para validación
        const validationParams = {
            device: this.isMobile ? "mobile" : "desktop",
            score_threshold: this.probabilityThreshold / 100,
            use_model: true,
            return_original: false,
            isFront: this.isFront,
            Suprimir: false,
            use_fast_detection: true,
        }

        // Enviar como JSON
        const message = {
            action: "validate_document",
            data: {
                image: imageData,
                ...validationParams,
            },
        }

        const messageStr = JSON.stringify(message)
        console.log(`SEND: Enviando mensaje JSON - Tamaño: ${messageStr.length} chars`, message.data)
        this.ws.send(messageStr)
        this.isProcessing = true
    }

    captureImage() {
        if (!this.videoElement) {
            console.log("ERROR: Video element no disponible")
            return null
        }

        try {
            const canvas = document.createElement("canvas")
            canvas.width = this.videoElement.videoWidth
            canvas.height = this.videoElement.videoHeight

            const ctx = canvas.getContext("2d", {
                alpha: false,
                desynchronized: false,
                willReadFrequently: false
            })
            // Configurar para máxima calidad
            ctx.imageSmoothingEnabled = true
            ctx.imageSmoothingQuality = 'high'
            ctx.drawImage(this.videoElement, 0, 0, canvas.width, canvas.height)

            const imageData = canvas.toDataURL("image/webp", 1.0)
            console.log(`INFO: Imagen capturada - Dimensiones: ${canvas.width}x${canvas.height}`)

            return imageData
        } catch (error) {
            console.log(`ERROR: Error capturando imagen: ${error.message}`)
            return null
        }
    }

    startAutoCapture() {
        if (this.autoCapture) {
            console.log("ERROR: Auto captura ya está activa")
            return
        }

        console.log(`CONNECTION: Iniciando auto captura con intervalo de ${this.captureIntervalMs}ms`)
        this.autoCapture = true

        const doCapture = () => {
            if (!this.autoCapture) return

            if (!this.isProcessing && this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.captureAndSend()
            } else if (this.isProcessing) {
                console.log(`INFO: Saltando captura - procesamiento en curso (intervalo: ${this.captureIntervalMs}ms)`)
            }

            // Programar la siguiente captura
            this.autoCaptureInterval = setTimeout(doCapture, this.captureIntervalMs)
        }

        // Iniciar la primera captura
        doCapture()
    }

    stopAutoCapture() {
        if (this.autoCaptureInterval) {
            clearTimeout(this.autoCaptureInterval)
            this.autoCaptureInterval = null
        }
        this.autoCapture = false
        console.log("CONNECTION: Auto captura detenida")
    }

    createCanvasForDrawingMask(video) {
        this.innerCanvas = document.createElement("canvas");
        this.innerCanvas.className = "canvas-on-video";
        this.innerCanvas.width = video.videoWidth;
        this.innerCanvas.height = video.videoHeight;
        this.videoElement.after(this.innerCanvas);
        if (this.innerCanvas.offsetWidth) {
            this.innerCanvas.setAttribute("style", `margin-left:${-(this.innerCanvas.offsetWidth / 2)}px; margin-top: ${-(this.innerCanvas.offsetHeight / 2)}px;`);
        }
    }

    connectWebSocket() {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            console.log("CONNECTION: Ya hay una conexión WebSocket activa")
            return
        }

        const wsUrl = "wss://iddetectapi-dev.ado-tech.com/ws/DocumentValidatorV2/ValidateDocument"
        console.log(`CONNECTION: Conectando a: ${wsUrl}`)

        this.ws = new WebSocket(wsUrl)

        this.ws.onopen = (event) => {
            console.log("CONNECTION: WebSocket conectado exitosamente")
        }

        this.ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data)

                // Manejar diferentes tipos de mensajes
                if (data.type === "connection") {
                    this.clientId = data.client_id
                    console.log(`CONNECTION: Cliente ID asignado: ${this.clientId}`)
                } else if (data.type === "status") {
                    // Actualizar estado de procesamiento
                    if (data.stage === "init") {
                        this.isProcessing = true
                    }
                    console.log(`RECEIVE: Mensaje recibido - Tipo: ${data.type}`, data)
                } else if (data.quality !== undefined && data.status !== undefined) {
                    // Respuesta final del procesamiento
                    this.isProcessing = false
                    this.lastStatus = data.status

                    if (this.onStatusChange) {
                        this.onStatusChange(data.status);
                    }

                    if (data.status === "success") {
                        this.autoCapturing({
                            isCard: false,
                            image: '',
                            documentName: '',
                            status: data.status,
                        });
                    }

                    console.log(`RECEIVE: Resultado final - Estado: ${data.status}`, data)
                } else {
                    console.log(`RECEIVE: Mensaje recibido - Tipo: ${data.type || "undefined"}`, data)
                }
            } catch (e) {
                console.log(`RECEIVE: Mensaje recibido (texto plano): ${event.data}`)
            }
        }

        this.ws.onclose = (event) => {
            console.log(`CONNECTION: WebSocket cerrado - Código: ${event.code}, Razón: ${event.reason}`)
            this.ws = null
        }

        this.ws.onerror = (error) => {
            console.log(`ERROR: Error en WebSocket: ${error.message || "Error desconocido"}`)
        }
    }

    disconnectWebSocket() {
        if (this.ws) {
            this.ws.close()
            this.ws = null
            console.log("CONNECTION: WebSocket desconectado manualmente")
        }
    }


    autoCapturing(result) {
        this.stream.autoCapturing({
            ...result,
            status: result.status,
            quality: result.isCard
        });
        this.counterSuccessfulResults = 0;
    }
}
